// extracted by mini-css-extract-plugin
export var labelWrapper = "_gi-0";